import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { captureClick, identifyUser, resetUser, trackPageView } from './mixpanel';

export function Analytics() {
  const { user, isAuthenticated, isLoading } = useAuth0();
  useEffect(() => {
    if (isLoading) return;
    if (isAuthenticated && user?.sub) identifyUser(user.sub, user.email);
    else {
      resetUser();
      trackPageView('login');
    }
  }, [isLoading, isAuthenticated, user?.sub, user?.email]);

  useEffect(() => {
    if (!isAuthenticated || !user?.sub) return;
    const userId = user.sub;
    const email = user.email;
    const resume = () => {
      if (document.visibilityState === 'visible') identifyUser(userId, email);
    };
    document.addEventListener('visibilitychange', resume);
    return () => document.removeEventListener('visibilitychange', resume);
  }, [isAuthenticated, user?.sub, user?.email]);

  useEffect(() => {
    document.addEventListener('click', captureClick, true);
    return () => document.removeEventListener('click', captureClick, true);
  }, []);
  return null;
}
